import { redirect } from 'react-router-dom';

import { handleAuthorizationCallback } from '../../auth-callback';

/**
 * Loader for the dedicated `/auth/callback` route.
 *
 * Only used if `REACT_APP_OIDC_REDIRECT_PATH` is set to `/auth/callback`
 * and the AuthProvider client is configured with that redirect URI.
 */
export const authCallbackLoader = async () => {
  await handleAuthorizationCallback();
  return redirect('/');
};